

































































import Vue from 'vue'
import { ProductCategory } from '@/model/productCategory'

enum MENU_PAGES {
  PARENT_CAT,
  CHILD_CAT
}
export default Vue.extend({
  props: {
    productCategories: {
      type: Array as () => ProductCategory[],
      default: () => []
    }
  },
  data(): {
    activeMenu: MENU_PAGES
    MENU_PAGES: typeof MENU_PAGES
    activeParentCategory: number
  } {
    return {
      activeMenu: MENU_PAGES.PARENT_CAT,
      MENU_PAGES: MENU_PAGES,
      activeParentCategory: -1
    }
  },
  computed: {
    childCategories(): ProductCategory[] {
      return this.productCategories.find(
        item => item.id === this.activeParentCategory
      )?.childCategories || []
    }
  },
  methods: {
    onSelectParentCategory(item: ProductCategory) {
      if (item.childCategories?.length) {
        this.activeParentCategory = item.id
        this.activeMenu = MENU_PAGES.CHILD_CAT
      } else {
        window.location.href = item.url
      }
    }
  }
})
